{
  "name": "dapp-coindepo-frontend",
  "version": "0.0.152",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --proxy-config ./proxy.conf.js",
    "start-stage": "ng serve --configuration stage --proxy-config ./proxy.conf.js",
    "start-prod": "ng serve --configuration production --proxy-config ./proxy.conf.js",
    "build-dev": "ng build --configuration development",
    "build-stage": "ng build --configuration stage",
    "build-prod": "ng build --configuration production",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "test:worker": "node --test \"tests/worker/*.test.mjs\"",
    "clear-cache": "ng cache clean",
    "prepare": "husky install",
    "build-dev-legacy": "ng build --configuration development",
    "start-dev-legacy": "ng serve --configuration dev-legacy --proxy-config ./proxy.conf.js",
    "build-dev-dual": "ng build --configuration dev-dual",
    "start-dev-dual": "ng serve --configuration dev-dual --proxy-config ./proxy.conf.js",
    "build-dev-cookie": "ng build --configuration dev-cookie",
    "start-dev-cookie": "ng serve --configuration dev-cookie --proxy-config ./proxy.conf.js",
    "build-stage-legacy": "ng build --configuration stage",
    "start-stage-legacy": "ng serve --configuration stage-legacy --proxy-config ./proxy.conf.js",
    "build-stage-dual": "ng build --configuration stage-dual",
    "start-stage-dual": "ng serve --configuration stage-dual --proxy-config ./proxy.conf.js",
    "build-stage-cookie": "ng build --configuration stage-cookie",
    "start-stage-cookie": "ng serve --configuration stage-cookie --proxy-config ./proxy.conf.js",
    "build-prod-legacy": "ng build --configuration production",
    "start-prod-legacy": "ng serve --configuration prod-legacy --proxy-config ./proxy.conf.js",
    "build-prod-dual": "ng build --configuration prod-dual",
    "start-prod-dual": "ng serve --configuration prod-dual --proxy-config ./proxy.conf.js",
    "build-prod-cookie": "ng build --configuration prod-cookie",
    "start-prod-cookie": "ng serve --configuration prod-cookie --proxy-config ./proxy.conf.js"
  },
  "private": true,
  "dependencies": {
    "@analogjs/vite-plugin-angular": "^1.8.0",
    "@angular/animations": "^18.2.0",
    "@angular/cdk": "^18.2.12",
    "@angular/common": "^18.2.0",
    "@angular/compiler": "^18.2.0",
    "@angular/core": "^18.2.0",
    "@angular/forms": "^18.2.0",
    "@angular/platform-browser": "^18.2.0",
    "@angular/platform-browser-dynamic": "^18.2.0",
    "@angular/router": "^18.2.0",
    "@coinbase/wallet-sdk": "^4.3.0",
    "@messageformat/core": "^3.4.0",
    "@ng-bootstrap/ng-bootstrap": "^16.0.0",
    "@ngx-translate/core": "^15.0.0",
    "@ngx-translate/http-loader": "^8.0.0",
    "@popperjs/core": "^2.11.8",
    "@reown/appkit": "^1.6.5",
    "@reown/appkit-adapter-ethers": "^1.6.5",
    "bootstrap": "^4.6.1",
    "buffer": "^6.0.3",
    "echarts": "^6.0.0",
    "ethers": "^6.13.5",
    "intl-messageformat": "^12.1.3",
    "jquery": "^3.6.0",
    "lodash": "^4.17.21",
    "ngx-bootstrap": "~8.0.0-RC.9",
    "ngx-cookie": "^6.0.1",
    "ngx-mask": "^18.0.0",
    "ngx-scrollbar": "^16.1.0",
    "ngx-toastr": "^19.0.0",
    "ngx-translate-messageformat-compiler": "^7.1.0",
    "process": "^0.11.10",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "viem": "^2.21.44",
    "zone.js": "~0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^18.2.1",
    "@angular/cli": "^18.2.1",
    "@angular/compiler-cli": "^18.2.0",
    "@types/jasmine": "~5.1.0",
    "@types/lodash": "^4.17.9",
    "husky": "^9.1.6",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "moment": "^2.30.1",
    "typescript": "~5.5.2"
  }
}
